<template>
  <div>
    <div>
      <div v-if="isShow">
        <OuterHeader
          ref="OuterHeader"
          @showRegister="showRegister()"
          @closeRegister="closeRegister()" />
      </div>
      <div v-else>
        <InnerHeader ref="InnerHeader" />
      </div>
    </div>
    <main role="main">
      <div
        class="hero-banner mb-5"
        :style="
          banner_image
            ? 'background-image:url(' + banner_image + ')'
            : 'background-image:url(../images/home-banner.jpg)'
        ">
        <div class="container">
          <div
            class="row align-items-center min-vh-100 content-wrap"
            style="text-align: inherit">
            <div class="col-lg-7 col-md-12">
              <!-- <p class="font-bold text-white">
                Welcome to Nimbalkar Maratha Vadhu Var Suchak
              </p> -->
              <h1
                class="text-white display-4 font-bold"
                style="text-align: inherit">
                Thousands of Marathas found their perfect match here!
              </h1>
              <button
                v-if="isShow"
                v-on:click="showRegister()"
                type="button"
                class="btn btn-brand-1">
                get started
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="page-content">
        <div class="container">
          <div class="container mb-md-5 mb-4">
            <div class="row align-items-lg-center">
              <div class="col-md-6 mb-md-0 mb-4">
                <img src="/images/most-trust.jpg" alt="" class="img-fluid" />
              </div>
              <div class="col-md-6">
                <p class="heading-small text-brand with-bg">WHO WE ARE</p>
                <h2 class="heading-2">
                  <!-- {{ $t("Home.most_trusted_exclusive_matrimony") }} -->
                  Most trusted & exclusive Matrimony
                </h2>
                <p>
                  We don’t just match profiles — we connect hearts and
                  families.<br />
                  Recognized as one of the most trusted and exclusive
                  matrimonial services, we are committed to guiding you through
                  one of life's most meaningful decisions with honesty, care,
                  and cultural respect.
                </p>

                <div class="row">
                  <div class="col-md-4">
                    <h3 class="h1 text-brand font-bold">35 Y+</h3>
                    <p class="text-uppercase">
                      <!-- {{ $t("Home.experience") }} -->/
                      Experience
                    </p>
                  </div>
                  <div class="col-md-6">
                    <h3 class="h1 text-brand font-bold">10,000+</h3>
                    <p class="text-uppercase">
                      <!-- {{ $t("Home.marriages_are_settled") }} -->
                      marriages are settled
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <section class="video-sec py-5" v-if="!loader">
            <div class="container py-md-4">
              <div class="row justify-content-center">
                <div class="col-lg-10">
                  <div class="video-box">
                    <!-- v-if="data.video_url.includes('youtube')" -->
                    <!-- src="https://www.youtube.com/watch?v=nkMr6VqtJRE" -->

                    <YouTube
                      v-if="video_link.includes('youtube')"
                      width="100%"
                      height="500"
                      :src="video_link" />
                    <video v-else controls style="width: 1100px">
                      <source
                        :src="video_link"
                        type="video/mp4"
                        width="900"
                        height="500" />
                    </video>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div class="container features py-md-5 py-4">
            <div class="text-center mb-5">
              <p class="heading-small text-brand with-bg">How We Work</p>
              <h2 class="heading-2">Features</h2>
            </div>

            <div class="row justify-content-center">
              <div class="col-lg-4 col-md-6 mb-md-4 mb-3">
                <div class="card features-card">
                  <img
                    src="images/users.svg"
                    width="40"
                    alt=""
                    class="mb-3 icon" />
                  <h4 class="text-uppercase font-bold font-xs-20">
                    <!-- {{ $t("Home.get_hand_picked_match_profile") }} -->
                    get hand picked match profile
                  </h4>
                  <p class="mb-0 text-secondary font-light">
                    We provide suggested match profiles that are thoughtfully
                    recommended based on your expectations, relations, and
                    background.
                  </p>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 mb-md-4 mb-3">
                <div class="card features-card">
                  <img
                    src="images/search-svgre.svg"
                    height="40"
                    width="40"
                    alt=""
                    class="mb-3 icon" />
                  <h4 class="text-uppercase font-bold font-xs-20">
                    <!-- {{ $t("Home.search_shortlist_by_your_choice") }} -->
                    search & shortlist by your choice
                  </h4>
                  <p class="mb-0 text-secondary font-light">
                    Search and shortlist profiles based on your expectations and
                    family's preferences.
                  </p>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 mb-md-4 mb-3">
                <div class="card features-card">
                  <img
                    src="images/ok.svg"
                    width="40"
                    alt=""
                    class="mb-3 icon" />
                  <h4 class="text-uppercase font-bold font-xs-20">
                    <!-- {{ $t("Home.send_receive") }} -->
                    send / receive
                    <br />
                    <!-- {{
                      // $t("Home.interest")

                    }} -->
                    interest
                  </h4>
                  <p class="mb-0 text-secondary font-light">
                    You can send and receive interest in profiles that truly
                    align with your preferences and values.
                  </p>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 mb-md-4 mb-3">
                <div class="card features-card">
                  <img
                    src="images/view-svgrepo.svg"
                    width="40"
                    alt=""
                    class="mb-3 icon" />
                  <h4 class="text-uppercase font-bold font-xs-20">
                    <!-- {{ $t("Home.view_contact_to_call_or_message_directly") }} -->
                    view contact to call or message directly
                  </h4>
                  <p class="mb-0 text-secondary font-light">
                    No waiting. No delays. you can immediately access contact
                    details of your shortlisted or matched profiles.
                  </p>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 mb-md-4 mb-3">
                <div class="card features-card">
                  <img
                    src="images/hand-shake.svg"
                    width="40"
                    alt=""
                    class="mb-3 icon" />
                  <h4 class="text-uppercase font-bold font-xs-20">
                    <!-- {{ $t("Home.meet_your_dream_partner") }} -->
                    meet your dream partner at YOUR PREFERRED LOCATION
                  </h4>
                  <p class="mb-0 text-secondary font-light">
                    Meet Your Dream Partner, Get to Know Them Better
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ErrorComponent @retry="getVideoLink(0)" ref="errorComponent" />
    </main>
    <SubFooter ref="SubFooter" @showRegister="showRegister()" />
    <MainFooter ref="MainFooter" @showRegister="showRegister()" />
    <SignUp ref="signupModal" />
  </div>
</template>
<script>
import OuterHeader from "@/components/OuterHeader";
import InnerHeader from "@/components/InnerHeader";
import ErrorComponent from "@/components/ErrorComponent";
import MainFooter from "@/components/MainFooter";
import SignUp from "../../components/signup.vue";
import SubFooter from "@/components/SubFooter.vue";
import YouTube from "vue3-youtube";
// import $ from "jquery";
//import router from "../../router";
export default {
  name: "HomeLanding",
  components: {
    OuterHeader,
    InnerHeader,
    ErrorComponent,
    MainFooter,
    SignUp,
    SubFooter,
    YouTube,
  },
  data() {
    return {
      loader: true,
      isShow: true,
      banner_image: "",
      video_link: "",
    };
  },

  mounted() {
    this.getBanner();
    this.getVideoLink();
    if (localStorage.getItem("access_token")) {
      this.isShow = false;
      this.$router.push("/dashboard");
    }
    //    $(".play-btn-wraper #PlayVdoBtn").click(function(){
    //    $(".play-btn-wraper").addClass("hideBtn")
    //    $('#video').trigger('play');

    //     });
    //     $(".play-btn-wraper #PauseVdoBtn").click(function(){
    //     $('#video').trigger('pause');
    //      $(".play-btn-wraper").removeClass("hideBtn")
    //      });
  },

  methods: {
    getBanner() {
      this.$api
        .getAPI({
          _action: "/banner/random",
        })
        .then((res) => {
          if (res.image) {
            this.banner_image = res.image;
          }
        })
        .catch(() => {});
    },
    getVideoLink() {
      this.loader = true;
      this.$refs.errorComponent.updateFormLoader(true);
      this.$api
        .getAPI({
          _action: "/cms/video-link",
        })
        .then((res) => {
          if (res.video_link) {
            this.video_link = res.video_link;
          }
          this.loader = false;
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(res, "");
            this.$refs.errorComponent.updateFormLoader(false);
          }
        })
        .catch(() => {
          this.$refs.errorComponent.updateFormLoader(false);
        });
    },
    showRegister() {
      this.$refs.signupModal.showModal();
    },
    closeRegister() {
      if(this.$refs.signupModal){
        this.$refs.signupModal?.closedModal();
      }
    },
  },
};
</script>
